import { useState } from "react";
import { Modal } from "react-bootstrap";

const NotificationPopup = ({ show, title }) => {
  const [modalShow, setModalShow] = useState(true);

  const handleClose = () => setModalShow(false);

  return (
    <Modal className="modal-notification" show={modalShow} onHide={handleClose}>
      <Modal.Header closeButton>
        <h4 style={{ marginBottom: "0px" }}>Duyuru !</h4>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            Türk Telekom tarafından yapılan bilgilendirmeye göre, ADSL- VDSL-
            Fiber DSL altyapılarında tarife değişikliği söz konusu olacaktır. Bu
            kapsamda; daha önce satışa kapanmış olan ancak hizmet alınmaya devam
            edilen tarifeler tamamıyla kullanıma kapatılacaktır. Mevcut DSL
            tarifeniz eğer AKN‘li (Adil Kullanım Noktası) paket ise, aynı hızda
            limitsiz paket olarak; AKN’li değil ise, aynı hızda veya bir üst
            hızı sunan paket olarak güncellenecektir. Konuyla ilgili e-posta ve
            kısa mesaj bilgilendirmesi yapılmıştır.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NotificationPopup;
